import { UNILATERAL_NON_TTR_REGISTRY } from './name';

import links from '@/utils/links';
import request from '@/utils/request';

export async function changeParametersMulti(context, params) {
  return await request.call(
    this,
    context,
    {
      url: links.measure.unilateralNonTrRegistry.changeParametersMulti,
      name: UNILATERAL_NON_TTR_REGISTRY.changeParametersMulti,
      method: 'put',
    },
    params,
  );
}

export async function findAuditLog(context, params) {
  return await request.call(
    this,
    context,
    {
      url: links.measure.unilateralNonTrRegistry.findAuditLog,
      name: UNILATERAL_NON_TTR_REGISTRY.findAuditLog,
    },
    params,
  );
}

export async function update(context, params) {
  return await request.call(
    this,
    context,
    {
      url: links.measure.unilateralNonTrRegistry.CRUD,
      name: UNILATERAL_NON_TTR_REGISTRY.update,
      method: 'put',
      pathParams: ['id'],
      deleteParamsInPath: false,
    },
    params,
  );
}
